import { TableBody, TableBodyProps } from './TableBody';
import { TableHead, TableHeadProps } from './TableHead';

type TableSectionProps = TableHeadProps & TableBodyProps;

export const TableSection = (props: TableSectionProps) => {
  return (
    <>
      <TableHead nameLabel={props.nameLabel} />
      <TableBody data={props.data} />
    </>
  );
};
